$(document).ready(function($) {
  if ($('.pdp-gallery').length) {
    $('.pdp-gallery').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.pdp-gallery-nav'
    });
    $('.pdp-gallery-nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.pdp-gallery',
      dots: false,
      focusOnSelect: true,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>'
    });
  }

  if (document.cookie.includes("cookie=true") || localStorage.getItem("hidecookiepopup") == "true") {
    $('.cookie-popup').hide();
  }

  function hideCookie() {
    $('.cookie-popup').addClass('cookie-slide');
    document.cookie = "cookie=true; expires=Fri, 31 Dec 9999 23:59:59 GMT";
  }

  function closeCookie() {
    $('.cookie-popup').addClass('cookie-slide');
    localStorage.setItem("hidecookiepopup", "true");
  }

  $('.cookie-info a.btn').click(function(){
    hideCookie();
  });
  $('.cookie-info button.btn').click(function(){
    closeCookie();
  });
  $('.cookie-popup .fa-times').click(function(){
    hideCookie();
  });

  // faq section accordion
  $(".question").click(function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      $('.answer').slideUp();
      $('.question').not(this).removeClass('active');
      $('.faq-inbox').removeClass('activeToggle');
      $(this).addClass('active');
      $(this).next('.answer').slideDown();
      $(this).parent().addClass("activeToggle"); 
    } else {
      $(this).removeClass('active');
      $(this).next('.answer').slideUp();
      $(this).parent().removeClass("activeToggle"); 	
    }
  });
});

$(window).resize(function(){
  if ($('.pdp-gallery').length) {
    $('.pdp-gallery')[0].slick.refresh();
    $('.pdp-gallery-nav')[0].slick.refresh();
  }
  megamenuToggle();
});
